<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑     永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2022-10-26 17:21:32
 * @LastEditTime: 2022-10-26 20:50:50
 * @Description: 合同详情-基础版
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\contractInfo\contractDetails_Basics.vue
 -->


<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="contractDetails_Basics">
            <van-nav-bar
                title="合同详情"
                left-text="合同列表"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <div class="msg-wrapper">
                    <van-cell
                        :value="detail.contract_number"
                        title="合同编号"
                        :icon="require('@/assets/images/icons/icon_gy_1.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.signing_date"
                        title="登记时间"
                        :icon="require('@/assets/images/icons/icon_gy_7.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.engineering_name"
                        title="工程名称"
                        :icon="require('@/assets/images/icons/icon_9.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.engineering_number"
                        title="工程编号"
                        :icon="require('@/assets/images/icons/icon_18.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.engineering_location"
                        title="工程地址"
                        is-link
                        :icon="require('@/assets/images/icons/icon_gy_2.png')"
                        @click="mapClick"
                    ></van-cell>
                    <van-cell
                        :value="detail.org_name"
                        title="供方单位"
                        :icon="require('@/assets/images/icons/icon_9.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.engineering_type_name"
                        title="工程类型"
                        :icon="require('@/assets/images/icons/icon_gy_5.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.monomer_names"
                        title="相关单体"
                        :icon="require('@/assets/images/icons/icon_gy_3.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.section"
                        title="标段"
                        :icon="require('@/assets/images/icons/icon_gy_3.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.client_name"
                        title="客户名称"
                        :icon="require('@/assets/images/icons/icon_3.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.client_type"
                        title="客户类型"
                        :icon="require('@/assets/images/icons/icon_3.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.client_uscc"
                        title="统一信用代码"
                        :icon="require('@/assets/images/icons/icon_40.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.client_contact_name"
                        title="客户联系人"
                        :icon="require('@/assets/images/icons/icon_3.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.client_contact_phone"
                        title="联系电话"
                        :icon="require('@/assets/images/icons/icon_4.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.salesman_name"
                        title="业务员"
                        :icon="require('@/assets/images/icons/icon_3.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.salesman_phone"
                        title="业务员电话"
                        :icon="require('@/assets/images/icons/icon_4.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.waiter_name"
                        title="服务人员"
                        :icon="require('@/assets/images/icons/icon_3.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.waiter_phone"
                        title="服务人员电话"
                        :icon="require('@/assets/images/icons/icon_4.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.projected_capacity"
                        title="预计方量"
                        :icon="require('@/assets/images/icons/icon_30.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.haul_distance"
                        title="运距"
                        :icon="require('@/assets/images/icons/icon_11.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.supply_site_name"
                        title="供货站点"
                        :icon="require('@/assets/images/icons/icon_gy_2.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.production_station_id"
                        title="生产站点"
                        :icon="require('@/assets/images/icons/icon_gy_2.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.signing_date"
                        title="签约时间"
                        :icon="require('@/assets/images/icons/icon_gy_7.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.predicted_startwork_time"
                        title="预计开工时间"
                        :icon="require('@/assets/images/icons/icon_gy_7.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.construction_enterprise"
                        title="施工单位"
                        :icon="require('@/assets/images/icons/icon_9.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.construction_uscc"
                        title="统一信用代码"
                        :icon="require('@/assets/images/icons/icon_40.png')"
                    ></van-cell>
                    <van-cell
                        :value="detail.contract_type_name"
                        title="合同类型"
                        :icon="require('@/assets/images/icons/icon_gy_5.png')"
                    ></van-cell>
                </div>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'contract-details-basics',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === this.backUrl) {
            this.$store.commit('noKeepAlive', 'contract-details');
        }
        next();
    },
    filters: {},
    data() {
        return {
            detail: {},
            backUrl: '/contractInfo',
        };
    },
    computed: {},
    watch: {},
    async created() {
        if (this.$route.params.obj?.cvid) {
            this.detail = await this.getDetailFun(this.$route.params.obj.cvid);
        }
    },
    activated() {},
    mounted() {},
    destroyed() {},
    methods: {
        // 工程地质
        mapClick() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'locationInfo', params: {
                address: this.detail.engineering_location,
                longitude: this.detail.x_coordinate_point,
                latitude: this.detail.y_coordinate_point,
            } });
        },
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: this.backUrl });
        },

        // 获取详情信息接口
        getDetailFun(cvid) {
            return this.$axios.$post(`/interfaceApi/sale/contract_manager/base_contract_info/${cvid}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.contractDetails_Basics
    height 100%
    section
        height calc(100% - 45rpx)
        -webkit-overflow-scrolling: touch;
        overflow: scroll;
        .msg-wrapper
            background-color #F0F0F0
            .van-cell
                display flex
                .van-cell__title
                    flex 1
                .van-cell__value
                    flex 2
                .van-cell__left-icon,
                .van-field__left-icon
                    line-height 24rpx
                    .van-icon__image
                        display: inline-block
                        vertical-align: text-bottom;
</style>
